// files.js
import AWS from 'aws-sdk';

const async_listObjectsV2 = params => {
  const s3 = new AWS.S3();
  return new Promise((resolve, reject) => {
    s3.listObjectsV2(params, (error, result) => {
      if (error !== null) return reject(error);
      resolve(result);
    });
  });
};

export const listObjectsV2 = async params => {
  // const s3 = new AWS.S3();
  // const objects = await promisify(s3.listObjectsV2, params);
  const objects = await async_listObjectsV2(params);
  return objects;
};

export const async_getObject = params => {
  const s3 = new AWS.S3();
  return new Promise((resolve, reject) => {
    s3.getObject(params, (error, result) => {
      if (error !== null) return reject(error);
      resolve(result);
    });
  });
};

export const async_headObject = params => {
  const s3 = new AWS.S3();
  return new Promise((resolve, reject) => {
    s3.headObject(params, (error, result) => {
      if (error !== null) return reject(error);
      resolve(result);
    });
  });
};

export const async_getSignedURL = params => {
  const s3 = new AWS.S3();
  return new Promise((resolve, reject) => {
    s3.getSignedUrl('getObject', params, (error, result) => {
      if (error !== null) return reject(error);
      resolve(result);
    });
  });
};



// WEBPACK FOOTER //
// ./src/utils/files/files.js